import { z } from 'zod';

const systemMemorySchema = z.object({
  total: z.string(),
  used: z.string(),
  free: z.string(),
  percentUsed: z.number(),
});

const systemDiskSchema = z.object({
  total: z.string(),
  used: z.string(),
  free: z.string(),
  percentUsed: z.number(),
});

const systemGpuSchema = z.object({
  name: z.string(),
  utilizationPercent: z.number(),
  memoryUsed: z.string(),
  memoryTotal: z.string(),
});

export const vaultSystemResponseSchema = z.object({
  hostname: z.string(),
  platform: z.string(),
  arch: z.string(),
  nodeVersion: z.string(),
  cpuModel: z.string(),
  cpuCores: z.number(),
  cpuUsagePercent: z.number(),
  memory: systemMemorySchema,
  disk: systemDiskSchema,
  uptimeSeconds: z.number(),
  gpu: systemGpuSchema.nullable().optional(),
});

export type IVaultSystemResponse = z.infer<typeof vaultSystemResponseSchema>;
